import { action, makeObservable, observable } from "mobx";
import { ErrorMessages } from "../errorMessage";
import Validator from "../validator";

export interface PartOfFarmModel {
    value: boolean | undefined;
    errorMessage: string;

    validatePartOfFarm: () => void;
}

export class DefaultPartOfFarm implements PartOfFarmModel {
    @observable value: boolean | undefined;
    @observable errorMessage: string;

    constructor(value: boolean | undefined) {
        makeObservable(this);

        this.value = value;
        this.errorMessage = "";
    }

    @action
    public validatePartOfFarm = () => {
        if (!Validator.inNotNullOrUndefined(this.value!)) {
            this.errorMessage = ErrorMessages.required;
        } else {
            this.errorMessage = "";
        }
    }
}
